module.exports = __webpack_public_path__ + "static/media/logo_colour.066fddb6.png";